export const toCapitalize = (name)=>{
    return name[0].toUpperCase() + name.slice(1)
}